import { initFadeIn, initSectionBgClassToggle } from "./components/animations";
import {
  triggerHeaderScroll,
  triggerGradientScroll,
  triggerGradientOnBgChange,
} from "./components/observers";
import initObjectsTable from "./components/datatables";
import initTabs from "./components/tabs";
import addAccordion from "./components/accordion";
import initStepsLineHeight from "./components/experienceModule";
import initPlanPanZoom from "./components/objects-panzoom";
import changeObjectPlans from "./components/changeObjectPlans";
import initPlanFunctions from "./components/objectPlans";
import AOS from "aos";
import tabSectionTriggers from "./components/tabSectionTriggers";
import initHashNavigation from "./components/hashNavigation";
import tippy from "tippy.js";
import { developmentsSlider } from "./components/swiper";
import { initGlobalPopup } from "./components/popup";

function extraInfoTippy() {
  const tippyElements = document.querySelectorAll("[data-extra-info-tippy]");
  if (tippyElements.length === 0) {
    return;
  }

  tippyElements.forEach((tippyElement) => {
    const tippyContent = tippyElement.dataset.tippyContent;
    if (!tippyContent) {
      return;
    }

    tippyElement.addEventListener("click", (e) => {
      e.stopPropagation();
      e.preventDefault();
    });

    tippy(tippyElement, {
      content: tippyContent,
      allowHTML: true,
      interactive: true,
      arrow: true,
      placement: "bottom-start",
      trigger: "mouseenter click",
      touch: true,
      theme: "light",
    });
  });
}

function openMenu() {
  function init() {
    const btn = document.querySelector(".mobile-menu-btn");
    const menu = document.querySelector(".mobile-menu-wrap");

    const menuItems = document.querySelectorAll(".primary-nav-mobile a");

    btn.addEventListener("click", () => {
      btn.classList.toggle("active");
      menu.classList.toggle("is-open");
      document.body.classList.toggle("mobile-menu-open");
    });

    const innerCTA = document.querySelector(".mobile-menu-wrap .btn-primary");

    innerCTA.addEventListener("click", () => {
      btn.click();
    });

    menuItems.forEach((item) => {
      item.addEventListener("click", () => {
        btn.click();
      });
    });
  }

  const isPresent = document.getElementsByClassName("mobile-menu-btn");
  if (isPresent.length > 0) {
    init();
  }
}

initFadeIn();

function runOnLoadAndDocumentReady() {
  extraInfoTippy();
  // Facebook Pixel gravity forms
  (function () {
    function fbqReady() {
      return typeof fbq === "function";
    }

    // Track form focus
    document.addEventListener("focusin", function (e) {
      var el = e.target;
      var form =
        el && el.closest(".gform_wrapper form, form.gform_wrapper, form.gform");
      if (!form) return;

      if (form.dataset.formStartFired === "1") return; // do not double
      form.dataset.formStartFired = "1";

      if (fbqReady()) {
        var formId =
          form.getAttribute("id") ||
          form.getAttribute("data-formid") ||
          undefined;
        var eventId = "fs_" + (formId || "gf") + "_" + Date.now();
        fbq("trackCustom", "FormStart", {
          formId: formId,
          event_source: "web",
          event_id: eventId,
        });
      }
    });

    // Gravity Forms trigger: gform_confirmation_loaded
    if (window.jQuery) {
      jQuery(document).on(
        "gform_confirmation_loaded",
        function (event, formId) {
          // Add class to body on successful form submission
          document.body.classList.add("form-submitted");

          if (!fbqReady()) return;

          var eventId = "fsub_" + formId + "_" + Date.now();

          // Pixel - Standard event for optimization (e.g. Lead)
          fbq("track", "Lead", {
            form_id: formId,
            content_name: "Gravity Forms",
            event_source: "web",
            event_id: eventId,
          });

          // Pixel - Custom event for conversion in Event Manager
          fbq("trackCustom", "FormSubmit", {
            formId: String(formId),
            event_source: "web",
            event_id: eventId,
          });
        }
      );
    }
  })();

  AOS.init({
    duration: 500, // values from 0 to 3000, with step 50ms
    once: true,
  });

  openMenu();
  triggerHeaderScroll();
  initStepsLineHeight();

  initObjectsTable();
  tabSectionTriggers();

  initTabs();
  addAccordion();
  initPlanPanZoom();
  changeObjectPlans();
  initPlanFunctions();
  initHashNavigation();
  developmentsSlider();
  initGlobalPopup();

  const backButton = document.querySelector(".back-button");
  if (backButton) {
    backButton.addEventListener("click", function () {
      var referrer = document.referrer;
      var homeUrl = backButton.getAttribute("data-home-url");
      if (referrer.indexOf(window.location.hostname) !== -1) {
        window.history.back();
      } else {
        window.location.href = homeUrl;
      }
    });
  }

  if (!document.body.classList.contains("home")) {
    // triggerGradientScroll();
    initSectionBgClassToggle();
  }

  if (document.body.classList.contains("home")) {
    triggerGradientOnBgChange();
  }
}

if (document.readyState !== "loading") {
  runOnLoadAndDocumentReady();
} else {
  document.addEventListener("DOMContentLoaded", function () {
    runOnLoadAndDocumentReady();
  });
}
